import React, { createContext, useReducer } from 'react';

const initialState = {};
const subscriptionContext = createContext(initialState);
const { Provider } = subscriptionContext;

const SubscriptionProvider = ({ children }) => {
  const [state, dispatch] = useReducer((contextState, action) => {
    const typeOptions = {
      SET_SUBSCRIPTIONS: {
        ...contextState,
        data: action.data,
        globallySuppressed: action.globallySuppressed,
      },
    };

    if (typeOptions[action.type]) {
      return typeOptions[action.type];
    }

    throw new Error();
  }, initialState);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { subscriptionContext, SubscriptionProvider };
